import { Box, Drawer, IconButton } from '@mui/material';
import { Fragment, useCallback, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const DrawerComponent = ({
  button,
  children,
  success,
  disabled = false,
  defaultOpen = false,
  onClose = () => {},
  autoFocus = false,
  onOpen = () => {},
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
    onClose(false);
  }, [onClose]);

  const handleOpen = useCallback(() => {
    setOpen(true);
    onOpen(true);
  }, [onOpen]);

  useEffect(() => {
    if (success) setOpen(false);
  }, [success]);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <Fragment>
      <Box
        onClick={disabled ? () => {} : () => handleOpen()}
        autoFocus={autoFocus}
      >
        {button}
      </Box>
      <Drawer
        open={open || false}
        onClose={handleClose}
        anchor={'right'}
        PaperProps={{
          sx: { width: { xs: '100%', md: '60%' } },
        }}
      >
        <Box sx={style}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: { xs: 'relative', md: 'absolute' },
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          {children}
        </Box>
      </Drawer>
    </Fragment>
  );
};

export default DrawerComponent;

const style = {
  bgcolor: 'background.paper',
  p: 4,
  pt: 10,
};
